import Nav from "@/components/Header/Nav/Nav.tsx";
import Footer from "@/components/Footer/Footer.tsx";

import GridComponent from "@/components/GridComponent/GridComponent";
import ImageContainer from "@/components/ImageContainer/ImageContainer";
import DoubleBlock from "@/components/DoubleBlock/DoubleBlock";
import PartnerForm from "@/components/ContactForm/PartnerForm";
import { useEffect } from "react";
import CookiePopupButton from "../components/CookieBanner/CookiePopupButton";

const gridData = [
  {
    icon: "/images/Grid/garant-ico.svg",
    title: "Geprüfte Qualität & Transparenz",
    description:
      "Reparaturen mit modernstem Equipment und Prüfständen. Detaillierte Prüfprotokolle garantieren höchste Sicherheit für Ihre Kunden.",
  },
  {
    icon: "/images/Grid/diagram-pers-ico.svg",
    title: "Technische Unterstützung",
    description:
      "Experten mit über 10 Jahren Erfahrung beraten Sie bei komplexen Fällen und helfen, optimale Lösungen zu finden.",
  },
  {
    icon: "/images/Grid/calculate-ico.svg",
    title: "Exklusive Einkaufskonditionen",
    description:
      "Profitieren Sie von speziellen Preisen und Großhandelskonditionen.",
  },

  {
    icon: "/images/Grid/check-ui-ico.svg",
    title: "Partnerportal-Zugang",
    description:
      "Bestellungen, Rechnungen und individuelle Konditionen einfach verwalten.",
  },
  {
    icon: "/images/Grid/graph-ico.svg",
    title: "Schnelle Garantie- & Rückgabeprozesse",
    description: "Bevorzugter Service mit unkomplizierter Abwicklung.",
  },
  {
    icon: "/images/Grid/deliv-ico.svg",
    title: "Zuverlässige Lieferung",
    description:
      "Optimierte Logistik für schnelle und termingerechte Bestellungen.",
  },
];

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);
  return (
    <div>
      <title>Partner – HIXA – DSG Getriebe Reparatur & Wartung</title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <Nav></Nav>
      <DoubleBlock
        leftTitle="Unsere Partner – Ihr Vorteil in der Welt der Automatik­getriebe"
        rightText="Die HIXA GmbH ist Ihr zuverlässiger Partner für hochwertige Automatikgetriebe-Lösungen. Wir unterstützen Werkstätten und technische Spezialisten in Deutschland und der EU mit erstklassigen Produkten und Services."
      ></DoubleBlock>
      <ImageContainer src="/images/partner-img.webp" alt="Partner" />
      <GridComponent
        items={gridData}
        title="Ihre Vorteile als Partner"
      ></GridComponent>
      <PartnerForm></PartnerForm>
      <CookiePopupButton></CookiePopupButton>
      <Footer></Footer>
    </div>
  );
};

export default Home;
